import { memo, useMemo, useState } from 'react';
import { BackgroundTransitionTemplateMock } from './types';

function MockTemplateVideoRenderer({
  element,
  scale
}: {
  element: BackgroundTransitionTemplateMock['timeline']['segments'][0]['elements'][0];
  scale: number;
}) {
  const [imageError, setImageError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const styles = useMemo(() => {
    const elementWidth = element.width || 0;
    const elementHeight = element.height || 0;
    const elementX = element.x || 0;
    const elementY = element.y || 0;
    const elementRotation = element.rotation || 0;
    const elementCropX = element.cropX || 0;
    const elementCropY = element.cropY || 0;
    const elementCropWidth = element.cropWidth || 0;
    const elementCropHeight = element.cropHeight || 0;
    const elementBorderRadius = element.borderRadius || 0;

    return {
      width: `${elementWidth * scale}px`,
      height: `${elementHeight * scale}px`,
      top: `${elementY * scale}px`,
      left: `${elementX * scale}px`,
      transform: `rotate(${elementRotation}deg)`,
      clipPath: `inset(${elementCropY * scale}px ${
        elementWidth * scale - (elementCropX * scale + elementCropWidth * scale)
      }px ${elementHeight * scale - (elementCropY * scale + elementCropHeight * scale)}px ${elementCropX * scale}px ${
        elementBorderRadius ? `round ${elementBorderRadius * scale}px` : ''
      })`,
      borderRadius: `${elementBorderRadius * scale}px`
    };
  }, [element, scale]);

  const imageSrc = useMemo(() => {
    return (imageError || isLoading) && element.poster ? element.poster : element.src;
  }, [imageError, isLoading, element.poster, element.src]);

  return (
    <img
      className="absolute inset-0 size-full object-fill"
      style={styles}
      src={imageSrc}
      alt="Template background"
      onError={() => setImageError(true)}
      onLoad={() => setIsLoading(false)}
    />
  );
}

export default memo(MockTemplateVideoRenderer);
